<template>
  <div>
    <b-loading :is-full-page="true" :active="!initialized"></b-loading>
    <section v-if="initialized" class="section is-main-section">
      <CardComponent>
        <h1 class="title">Your Events</h1>
        <b-tabs>
          <b-tab-item label="Upcoming">
            <ManageEventCard
              v-for="event in upcomingEvents"
              :key="event._id"
              :event="event"
            />
          </b-tab-item>
          <b-tab-item label="Past">
            <ManageEventCard
              v-for="event in pastEvents"
              :key="event._id"
              :event="event"
            />
          </b-tab-item>
        </b-tabs>
      </CardComponent>
    </section>
  </div>
</template>

<script>
import CardComponent from '@/components/CardComponent'
import ManageEventCard from '@/components/ManageEventCard'
import EventApi from '@/api/event'
import EventBus from '@/eventbus'

export default {
  name: 'Home',
  components: {
    CardComponent,
    ManageEventCard,
  },
  data() {
    return {
      events: [],
      initialized: false,
    }
  },
  computed: {
    upcomingEvents() {
      if (this.events.length > 0) {
        return this.events.filter(
          (event) => new Date(event.eventenddate) >= new Date()
        )
      }
      return []
    },
    pastEvents() {
      if (this.events.length > 0) {
        return this.events.filter(
          (event) => event.active && new Date(event.eventenddate) < new Date()
        )
      }
      return []
    },
  },
  async created() {
    this.events = await EventApi.userevents()
    this.initialized = true
    EventBus.$on('refresh-events', async () => {
      this.initialized = false
      this.events = await EventApi.userevents()
      this.initialized = true
    })
  },
  methods: {},
}
</script>
